import { render, staticRenderFns } from "./signaturepad.vue?vue&type=template&id=0462349d&"
import script from "./signaturepad.vue?vue&type=script&lang=ts&"
export * from "./signaturepad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0462349d')) {
      api.createRecord('0462349d', component.options)
    } else {
      api.reload('0462349d', component.options)
    }
    module.hot.accept("./signaturepad.vue?vue&type=template&id=0462349d&", function () {
      api.rerender('0462349d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/signaturepad.vue"
export default component.exports